// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"622":"b9347803","977":"2899dd08"}[chunkId] + ".chunk.js";
};